import React from "react";
import { Link } from "react-router-dom";
import { Clock, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useSavedViews } from "@/lib/useSavedViews";
import { useRecents } from "./useRecents";

/** Top bar: the records the person starred, and the ones they opened last */
export function RecentMenu() {
  const recents = useRecents();
  const { views, reload } = useSavedViews("favourite");
  return (
    <Popover onOpenChange={(o) => o && void reload()}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label="Favourites and recently viewed" title="Favourites and recently viewed">
          <Star className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="max-h-[70vh] overflow-y-auto py-1.5 text-sm">
          <h3 className="flex items-center gap-1.5 px-3 pb-1 pt-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            <Star className="size-3" /> Favourites
          </h3>
          {views.length ? (
            views.map((v) => (
              <Link key={v.id} to={String(v.config.to)} className="flex flex-col px-3 py-1.5 hover:bg-muted">
                <span className="truncate font-medium">{String(v.config.label || v.name)}</span>
                <span className="truncate text-xs text-muted-foreground">{[v.config.entity, v.config.sub].filter(Boolean).join(" · ")}</span>
              </Link>
            ))
          ) : (
            <p className="px-3 py-2 text-xs text-muted-foreground">Star a record in its quick look to keep it here.</p>
          )}
          <h3 className="mt-1 flex items-center gap-1.5 border-t border-border px-3 pb-1 pt-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            <Clock className="size-3" /> Recently viewed
          </h3>
          {recents.length ? (
            recents.map((r) => (
              <Link key={`${r.entity}-${r.id}`} to={r.to} className="flex flex-col px-3 py-1.5 hover:bg-muted">
                <span className="truncate font-medium">{r.label}</span>
                <span className="truncate text-xs text-muted-foreground">{[r.entity, r.sub].filter(Boolean).join(" · ")}</span>
              </Link>
            ))
          ) : (
            <p className="px-3 py-2 text-xs text-muted-foreground">Records you open will show up here.</p>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
